import React, { useRef } from "react";
import OTPInput from "react-otp-input";
import { useTheme } from "@mui/material";
import "../styles/Signup.css";

function OTPinput(
  {
    otp,
    setOtp,
    setSubmissionStatus = () => {},
    inputClassName = "grm-otp-input-box",
    // Inline style object — takes priority over inputClassName when given
    // (react-otp-input's inputStyle applies a className for a string, inline
    // style for an object). Lets one consumer (FarmerDbtVerification's/
    // FarmerLoginForm's boxed OTP digits, Figma 639-88408/91-28910) opt into
    // theme-driven styling without touching the other consumers of this
    // shared component. Backported from rp-revamp-scheme-3547-handoff ahead
    // of this branch's eventual rebase (BLOCKERS.md B13).
    inputSx,
    // Opt-in — only the OtpInputRenderer family (FarmerDbtVerification.js)
    // passes this. Other OTPinput consumers (legacy popups: VerifyOtpModal,
    // ChangeNumOTPPopup, Agent/OTPPopup, MemberDetails) keep the default
    // `renderSeparator` spacing untouched.
    boxGap,
  },
  inputId,
) {
  const inputRefs = useRef([]);
  const theme = useTheme();

  const handleChange = (otp) => {
    if (/^\d*$/.test(otp) && otp.length <= 6) {
      setOtp(otp);
      setSubmissionStatus({
        message: "",
        success: false,
        submitted: false,
      });
      const currentInputIndex = otp.length;
      if (currentInputIndex < inputRefs.current.length) {
        inputRefs.current[currentInputIndex].focus();
      }
    }
  };
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index]) {
      if (index > 0) {
        inputRefs.current[index - 1].focus();
      }
    }
  };
  const customRenderInput = (props, index) => (
    <input
      {...props}
      // react-otp-input only applies inputStyle as EITHER a className OR
      // inline style, never both (see index.js) — so when a consumer passes
      // inputSx (object → inline style), props.className comes back
      // undefined. Append the spinner-hiding class unconditionally so every
      // consumer gets it regardless of which mode is in play.
      className={`${props.className || ""} otp-input-no-spinner`.trim()}
      ref={(el) => (inputRefs.current[index] = el)}
      onKeyDown={(e) => handleKeyDown(e, index)}
      autoFocus={index === 0}
    />
  );

  return (
    <OTPInput
      id={inputId}
      value={otp}
      inputType={"number"}
      onChange={handleChange}
      numInputs={6}
      containerStyle={{
        justifyContent: "center",
        ...(boxGap != null ? { gap: theme.spacing(boxGap) } : {}),
      }}
      shouldAutoFocus={true}
      inputStyle={inputSx || inputClassName}
      renderSeparator={boxGap != null ? null : <span>&nbsp;</span>}
      renderInput={(props, index) => customRenderInput(props, index)}
    />
  );
}

export default OTPinput;
